<template>
  <a :href="row[col.field]" target="_blank">{{row[col.field]}}</a>
</template>

<script>
export default {
  name: 'TemplateEmail',
  props: {
    row: { type: Object, required: true },
    col: { type: Object, required: true },
    template: { type: Object, required: true }
  }
}
</script>
